import UiAdapter from './uiAdapterExtended';
import { eSounds } from '../enums/eSounds';

const uiConfig = {
  H: {
    blacked_out: true,
    offsets: {
      right_panel: { top: 0, left: -11 },
      tournaments_panel: { top: 70, left: -1440 },
      bottom_panel: { top: 0, left: 0 },
    }
  },
  V: {
    blacked_out: true,
    offsets: {
      top: -30,
      left: 0,
      tournaments_panel: { top: 70 }
    }
  }
};

const initUi = () => {
  const ControllerUi = window.OPWrapperService.initUi(uiConfig);
  new UiAdapter(ControllerUi).init({
    clickSound: { soundName: eSounds.EST_BUTTON_CLICK.name, volume: 0.7, group: 'default' },
  });
}

export {
  initUi,
}
